import { render, staticRenderFns } from "./header-back-button.vue?vue&type=template&id=1599fe4c"
import script from "./header-back-button.vue?vue&type=script&lang=js"
export * from "./header-back-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports